import { convertLogMessageToELKLog } from '../Log/convertLogMessageToELKLog.js';
import { LogLevel, LogLevelInt } from '../Log/ILog.js';

/**
 * Интерфейс предоставляет методы для логирования ошибок, предупреждений, информационных собщений и отладочной
 * информации. `Logger` использует несколько этапов фильтрации сообщений, прежде чем отправить их в транспорт.
 * {@linkcode Logger.level} определяет минимальный уровень логирования {@linkcode LogLevel}, если уровнь лога
 * ниже установленного в логгере, то сообщение будет проигноировано. На втором этапе логгер может использовать
 * фильтр {@link IFilter}.
 *
 * Перед отправкой логи будут преобразованы в формат {@link IBaseAppELKLog}. После этого логи будут отправлены
 * в транспорт {@link ITransport}.
 *
 * @export
 * @class Logger
 */
class Logger {
    /**
     * Имя логгера
     *
     * @type {string}
     * @memberof Logger
     */
    name;
    /**
     * Уровень логирования
     *
     * @type {LogLevel}
     * @memberof Logger
     */
    level;
    filter;
    _transport;
    constructor(params) {
        this._transport = params.transport;
        this.name = params.name;
        this.filter = params.filter;
        this.level = params.level || LogLevel.Info;
    }
    /**
     * Позволяет поменять транспорт
     *
     * @param {ITransport} transport
     * @memberof Logger
     */
    setTransport(transport) {
        this._transport = transport;
    }
    rawLog(log) {
        if (LogLevelInt[this.level] <= LogLevelInt[log.level]) {
            if (this.filter && !this.filter.approve(log)) {
                return;
            }
            this._transport.write(log);
        }
    }
    get debugEnabled() {
        return LogLevelInt[this.level] <= LogLevelInt[LogLevel.Debug];
    }
    debug(log) {
        if (LogLevelInt[this.level] <= LogLevelInt[LogLevel.Debug]) {
            if (this.filter && !this.filter.approve(log)) {
                return;
            }
            this._transport.write(convertLogMessageToELKLog(LogLevel.Debug, log));
        }
    }
    info(log) {
        if (LogLevelInt[this.level] <= LogLevelInt[LogLevel.Info]) {
            if (this.filter && !this.filter.approve(log)) {
                return;
            }
            this._transport.write(convertLogMessageToELKLog(LogLevel.Info, log));
        }
    }
    warn(log) {
        if (LogLevelInt[this.level] <= LogLevelInt[LogLevel.Warning]) {
            if (this.filter && !this.filter.approve(log)) {
                return;
            }
            this._transport.write(convertLogMessageToELKLog(LogLevel.Warning, log));
        }
    }
    error(log) {
        if (LogLevelInt[this.level] <= LogLevelInt[LogLevel.Error]) {
            if (this.filter && !this.filter.approve(log)) {
                return;
            }
            this._transport.write(convertLogMessageToELKLog(LogLevel.Error, log));
        }
    }
    fatal(log) {
        if (LogLevelInt[this.level] <= LogLevelInt[LogLevel.Fatal]) {
            if (this.filter && !this.filter.approve(log)) {
                return;
            }
            this._transport.write(convertLogMessageToELKLog(LogLevel.Fatal, log));
        }
    }
}

export { Logger };
//# sourceMappingURL=Logger.js.map
